import { ProductCarousal } from '@commerce-webcomponents/ui-composite';
import { useSession, useTranslation } from '@nextgen-web-framework/all';
import { memo } from 'react';
import { AprContainerKey } from './types/enums';
import styles from './RecommendedProducts.module.scss';

const RecommendedProducts = () => {
  const { isAnonymous } = useSession();
  const t = useTranslation();

  const productCarouselPropsData = [
    {
      title: t('product.composite.productContainer.recommendedForYou'),
      aprContainerKey: AprContainerKey.RECOMMENDED_FOR_YOU,
    },
  ];
  if (!isAnonymous()) {
    productCarouselPropsData.push({
      title: t('product.composite.productContainer.yourFavorites'),
      aprContainerKey: AprContainerKey.YOUR_FAVORITES,
    });
  }

  return (
    <>
      <div className={styles['recommended-products-container']}>
        {productCarouselPropsData.map((ProductCarouselProps) => (
          <ProductCarousal
            componentType={'product_carousel'}
            products={[]}
            type="vertical"
            pageName="product"
            slots={4}
            key={ProductCarouselProps.title}
            {...ProductCarouselProps}
          />
        ))}
      </div>
    </>
  );
};

export default memo(RecommendedProducts);
